<script lang="ts">
    import { lockBodyScroll, unlockBodyScroll } from '@components/utils/body-scroll';

    import s from './overlay-wrapper.module.css';

    export let isOpen = false;

    $: if (isOpen) {
        lockBodyScroll('overlay');
    } else {
        unlockBodyScroll('overlay');
    }
</script>

{#if isOpen}
    <div class={s.root} data-bodyscrollignore>
        <slot></slot>
    </div>
{/if}
